import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name.split(" ")[0]}!`);
      navigate(u.role === "admin" ? "/admin" : "/");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="login-page">
      <h1 className="font-display text-4xl text-deepbrown font-bold">Welcome back</h1>
      <p className="text-deepbrown/60 mt-2">Sign in to your Sutrakosh account.</p>

      <form onSubmit={onSubmit} className="mt-8 space-y-4 bg-white rounded-2xl p-6 border border-deepbrown/10">
        <div>
          <Label>Email</Label>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
        </div>
        <div>
          <Label>Password</Label>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
        </div>
        <button type="submit" disabled={submitting} className="w-full py-3 rounded-full bg-rani text-white font-bold hover:scale-[1.01] transition-transform disabled:opacity-50" data-testid="login-submit">
          {submitting ? "Signing in…" : "Sign In"}
        </button>
        <p className="text-sm text-center text-deepbrown/60">
          New here? <Link to="/register" className="text-rani font-semibold" data-testid="register-link">Create an account</Link>
        </p>
      </form>

    </div>
  );
}
